// extracted by mini-css-extract-plugin
module.exports = {"container":"form_container__bdqc4","button":"form_button__YgIju","passwordResetButton":"form_passwordResetButton__AO2Oj"};